import { Box, Drawer, useMediaQuery } from "@mui/material";
import React from "react";
import ParticipantSidebar from "./ParticipantSidebar";

type Props = {
  showDrawer: boolean;
  setShowDrawer: React.Dispatch<React.SetStateAction<boolean>>;
};

const SidebarDrawer = ({ showDrawer, onClose, isMobile }: any) => (
  <Drawer
    open={showDrawer}
    onClose={onClose}
    PaperProps={{
      sx: { maxWidth: "100%" },
    }}
  >
    <ParticipantSidebar isMobile={isMobile} />
  </Drawer>
);

const ParticipantSidebarWrapper: React.FC<Props> = ({
  showDrawer,
  setShowDrawer,
}) => {
  const isMobile = useMediaQuery("(max-width:900px)");

  const onClose = () => {
    setShowDrawer(false);
  };

  return (
    <>
      {!isMobile && (
        <Box
          sx={{
            display: { xs: "none", md: "block" },
            height: "100%",
            position: "sticky",
            top: 0,
          }}
        >
          <ParticipantSidebar isMobile={isMobile} />
        </Box>
      )}

      {showDrawer && (
        <SidebarDrawer
          showDrawer={showDrawer}
          onClose={onClose}
          isMobile={isMobile}
        />
      )}
    </>
  );
};

export default ParticipantSidebarWrapper;
